import { createApp } from 'vue'
import LocationCard from './LocationCard'

const el = '.kb-component--location-card'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((LocationCardDOM) => {
            const component = createApp(LocationCard).use(Store)
            component.mount(LocationCardDOM)
        })
    }
}
